import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import supportImg from 'src/assets/support.svg';

import PageHeader from '../../../ui/PageHeader/PageHeader';
import classes from './AdminHome.module.scss';

const AdminHome: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.Container}>
      <PageHeader title={t('common:dashboard')} className={classes.Header} />
      <section>
        <h4>{t('dashboard:welcome_admin')}</h4>
        <p>{t('dashboard:dashboard_details')}</p>
        <img src={supportImg} alt={'support'} />
      </section>
    </div>
  );
};

export default AdminHome;
